export const EVENT_PAGE_INFO_READY = 'EVENT_PAGE_INFO_READY';
